import { Icon } from '@components/primitives/Icon'
import { FontAwesomeSvgIcon } from '@components/primitives/Icon/FontAwesomeSvgIcon'
import { PowerPreferredIcon } from '@components/primitives/Icon/PowerPreferredIcon'
import { faBadge } from '@fortawesome/pro-solid-svg-icons/faBadge'
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { colors } from '@lib/colors/colors'

export function SiteStatusBadge({
  activeContractWithSponsor,
  currentRank,
}: {
  activeContractWithSponsor?: boolean
  currentRank?: string
}) {
  // if no props passed return null
  if (!activeContractWithSponsor && !currentRank) {
    return null
  }

  switch (currentRank) {
    case 'SuperSite':
      return (
        <div className='inset-x-0 top-0 flex h-9 items-center rounded-t-lg bg-primary100'>
          <span className='relative flex size-4 items-center justify-center pl-8'>
            <Icon
              className='absolute size-4 text-primary600 antialiased'
              icon={faBadge}
            />
            <FontAwesomeSvgIcon
              className='absolute size-[10px] text-primary50 antialiased'
              icon={faStar}
            />
          </span>
          <span className='ml-3 text-nowrap text-sm font-bold leading-normal text-primary600 antialiased'>
            SuperSite
          </span>
        </div>
      )
    case 'PowerPreferred':
      return (
        <div className='inset-x-0 top-0 flex h-9 items-center rounded-t-lg bg-primary100'>
          <span className='relative flex size-5 items-center justify-center pl-8'>
            <Icon className='absolute size-5 text-primary600' icon={faBadge} />
            <div className='absolute mt-[1px]'>
              <PowerPreferredIcon color={colors.white} size={11} />
            </div>
          </span>
          <span className='ml-4 text-nowrap text-sm font-bold leading-normal text-primary600 antialiased'>
            Power Preferred
          </span>
        </div>
      )
  }
  if (activeContractWithSponsor) {
    return (
      <div className='inset-x-0 top-0 flex h-9 items-center rounded-t-lg bg-primary50'>
        <div className='flex items-center pl-6'>
          <Icon className='mr-1 text-black' icon={faBolt} size='2xs' />
          <span className='mt-[1px] text-nowrap text-sm font-semibold leading-normal text-black'>
            Active on Power
          </span>
        </div>
      </div>
    )
  }
}
